import { useStyledTheme } from '@openeducation/oe-it-themes';
import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import type { FontAwesome5IconProps } from 'react-native-vector-icons/FontAwesome5';

import { height, margin, opacity, width } from '../../style-utils';
import { CircleIcon } from '../circle-icon/circle-icon';

export type CircleIconButtonProps = FontAwesome5IconProps &
  TouchableOpacityProps & {
    iconSize?: number;
    backgroundColor?: string;
    borderColor?: string;
    nativeID?: string;
  };

export const CircleIconButton = ({
  onPress,
  name,
  iconSize = 20,
  size = 40,
  color,
  backgroundColor,
  borderColor,
  disabled,
  ...props
}: CircleIconButtonProps) => {
  const { color: colors } = useStyledTheme();

  return (
    <TouchableOpacity
      style={[width(size), height(size)]}
      onPress={onPress}
      disabled={disabled}
      {...props}
    >
      <CircleIcon
        style={[margin(0), opacity(disabled ? 0.75 : 1)]}
        backgroundColor={disabled ? colors.disabledGrayedOut : backgroundColor}
        borderColor={borderColor}
        name={name}
        color={disabled ? colors.dark2 : color}
        size={size}
        iconSize={iconSize}
        pointerEvents="none"
      />
    </TouchableOpacity>
  );
};

export default CircleIconButton;
